import { render, staticRenderFns } from "./403.vue?vue&type=template&id=56bdccad&scoped=true&"
import script from "./403.vue?vue&type=script&lang=js&"
export * from "./403.vue?vue&type=script&lang=js&"
import style0 from "./403.vue?vue&type=style&index=0&id=56bdccad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bdccad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1722063031/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56bdccad')) {
      api.createRecord('56bdccad', component.options)
    } else {
      api.reload('56bdccad', component.options)
    }
    module.hot.accept("./403.vue?vue&type=template&id=56bdccad&scoped=true&", function () {
      api.rerender('56bdccad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/errors/403.vue"
export default component.exports